var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("admin.bom_formats_desc")))]),
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("admin.bom_formats"),
                "label-size": "lg",
                "label-class": "font-weight-bold pt-0 mb-2",
              },
            },
            [
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: { color: "primary", label: "" },
                    model: {
                      value: _vm.isCycloneDXEnabled,
                      callback: function ($$v) {
                        _vm.isCycloneDXEnabled = $$v
                      },
                      expression: "isCycloneDXEnabled",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(_vm._s(_vm.$t("admin.enable_bom_cyclonedx")) + "\n    "),
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("admin.bom_validation"),
                "label-size": "lg",
                "label-class": "font-weight-bold pt-0 mb-2",
              },
            },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("admin.bom_validation_mode"),
                    "label-for": "bomValidationModeRadio",
                  },
                },
                [
                  _c(
                    "b-form-radio-group",
                    {
                      attrs: { id: "bomValidationModeRadio" },
                      model: {
                        value: _vm.bomValidationMode,
                        callback: function ($$v) {
                          _vm.bomValidationMode = $$v
                        },
                        expression: "bomValidationMode",
                      },
                    },
                    [
                      _c(
                        "b-input-group",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-input-group-text",
                            { staticClass: "justify-content w-25" },
                            [
                              _c(
                                "b-form-radio",
                                { attrs: { value: "ENABLED" } },
                                [_vm._v(_vm._s(_vm.$t("admin.enabled")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-input-group",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-input-group-text",
                            { staticClass: "justify-content w-25" },
                            [
                              _c(
                                "b-form-radio",
                                { attrs: { value: "DISABLED" } },
                                [_vm._v(_vm._s(_vm.$t("admin.disabled")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-input-group",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-input-group-text",
                            { staticClass: "justify-content w-25" },
                            [
                              _c(
                                "b-form-radio",
                                { attrs: { value: "ENABLED_FOR_TAGS" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("admin.enabled_for_tags"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("vue-tags-input", {
                            staticClass: "w-100 bg-transparent text-lowercase",
                            attrs: {
                              id: "input-4",
                              tags: _vm.bomValidationTagsInclusive,
                              "add-on-key": _vm.addOnKeys,
                              placeholder: _vm.$t("message.add_tag"),
                            },
                            on: {
                              "tags-changed": (newTags) =>
                                (this.bomValidationTagsInclusive = newTags),
                            },
                            model: {
                              value: _vm.bomValidationTagInclusive,
                              callback: function ($$v) {
                                _vm.bomValidationTagInclusive = $$v
                              },
                              expression: "bomValidationTagInclusive",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-input-group",
                        { staticClass: "mb-2" },
                        [
                          _c(
                            "b-input-group-text",
                            { staticClass: "justify-content w-25" },
                            [
                              _c(
                                "b-form-radio",
                                { attrs: { value: "DISABLED_FOR_TAGS" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("admin.disabled_for_tags"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("vue-tags-input", {
                            staticClass: "w-100 bg-transparent text-lowercase",
                            attrs: {
                              id: "input-4",
                              tags: _vm.bomValidationTagsExclusive,
                              "add-on-key": _vm.addOnKeys,
                              placeholder: _vm.$t("message.add_tag"),
                            },
                            on: {
                              "tags-changed": (newTags) =>
                                (this.bomValidationTagsExclusive = newTags),
                            },
                            model: {
                              value: _vm.bomValidationTagExclusive,
                              callback: function ($$v) {
                                _vm.bomValidationTagExclusive = $$v
                              },
                              expression: "bomValidationTagExclusive",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }